import React, { useEffect } from 'react';
import { formInputTextErrorStyle, routes } from 'Utility/constants';
import { withRouter } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as actions from '../../../redux/actions/index';
import { connect, useDispatch, useSelector } from 'react-redux';
import { validateForgotForm } from '../../../Utility/validator/formValidation';
import Loader from 'react-loader-spinner';

const ForgotPassword = (props) => {
   let dispatch = useDispatch();

   const initialFormValues = {
      email: '',
   };

   useEffect(() => {
      if (
         props.forgotPasswordSuccessAPI &&
         props.forgotPasswordSuccessAPI.success === true
      ) {
         props.history.push(routes.LOGIN);
      }
   }, [props.forgotPasswordSuccessAPI]);

   let isLoading = useSelector((state) => state.authReducer.isLoading);

   return (
      <div id="wrap">
         <div className="wrap-login100">
            <Formik
               initialValues={initialFormValues}
               onSubmit={(values) => {
                  dispatch(actions.forgotPassword({ user: { ...values } }));
               }}
               validate={(values) => validateForgotForm(values)}
            >
               <Form className="login100-form validate-form">
                  <span className="login100-form-title">Forgot Password</span>
                  <fieldset className="form_fields">
                     <div className="form-group">
                        <Field
                           className="input_modify text-lowercase"
                           type="email"
                           name="email"
                           placeholder="Email"
                        />
                        <ErrorMessage
                           name="email"
                           render={(msg) => (
                              <span style={formInputTextErrorStyle}>{msg}</span>
                           )}
                        />
                     </div>
                  </fieldset>
                  <div className="form-group text-center">
                     <button
                        disabled={isLoading ? true : false}
                        type="submit"
                        className="theme_btn theme_primary btn-block"
                     >
                        {isLoading ? (
                           <Loader
                              type="Circles"
                              color="#FFF"
                              height={25}
                              width={80}
                           />
                        ) : (
                              'Submit'
                           )}
                     </button>
                  </div>
                  <div className="ihweb_flex_btwn_Vc text-center"></div>
               </Form>
            </Formik>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      forgotPasswordSuccessAPI: state.authReducer.forgotPasswordSuccessAPI,
   };
};

const RforgotPassword = connect(mapStateToProps)(ForgotPassword);

export default withRouter(RforgotPassword);
